/**
 * What keeps Approve off for a step. These six causes are the whole list: a hint on the rep's own
 * edit (`web/draft-hints.tsx`) is advice and is deliberately not an input here, so it can never
 * disable the button.
 */
export type ApproveGate = {
  /** A command for this plan is in flight. */
  readonly busy: boolean;
  /** The draft has edits that are not saved yet. */
  readonly editing: boolean;
  /** Every step this one waits on is done, such as an open question. */
  readonly dependenciesSatisfied: boolean;
  /** The draft answers an older message than the lead's newest. */
  readonly staleDraft: boolean;
  /** The draft says a file is attached and that file is not ready. */
  readonly materialBlocked: boolean;
  /** A core v2 draft's commitment slots are not confirmed yet (`draft-slots.ts`). */
  readonly slotsUnresolved: boolean;
};

export function approveBlocked(gate: ApproveGate): boolean {
  return (
    gate.busy ||
    gate.editing ||
    !gate.dependenciesSatisfied ||
    gate.staleDraft ||
    gate.materialBlocked ||
    gate.slotsUnresolved
  );
}
